export const CREATIVE_ID_DASHBOARD_LISTINGS = 'dashboard-private-party-listings';
export const PRIVATE_PARTY_THANK_YOU = 'privatePartyThankYou';

export const OTHER = 'other';
export const BUTTON_TEXT_MORE = 'More';

export const MODAL_THANK_YOU_BG_HEIGHT = 74;
export const MODAL_BG_HEIGHT = 212;
export const MODAL_MOBILE_BG_HEIGHT = 270;

export const CONTINUE_CTA_TEXT = 'Continue';
export const PRIVATE_PARTY_SELL_CAR_CTA = 'List My Car to Sell';
export const PRIVATE_PARTY_LISTING_PRICE_COPY = 'List your car for 90 days for only $19.99';
export const WHY_NOT_APPROVED = 'Why was this listing not approved';
export const EDIT_RESUBMIT = 'Edit & Resubmit';
export const PRIVATE_PARTY_EDMUNDS = 'PRIVATE_PARTY_EDMUNDS';
export const PRIVATE_PARTY_APPRAISAL_LABEL = 'Private Party Appraisal';

export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

export const SUPPORT_LINK = 'https://help.edmunds.com/hc/en-us/requests/new';
export const EDIT_LISTING_LINK = '/sell-car/private/edit-listing/vehicle-details/';

export const CREATIVE_ID_ENTRY_PRIVATE_PARTY = 'edm-entry-private-party';
export const CREATIVE_ID_ENTRY_PRIVATE_PARTY_APPRAISAL_REPORT = 'edm-entry-private-party-appraisal-report';
const IMG_SRC_V2 = '/img/car-buying/private-party/lady-in-chair-chilling.png';
const IMG_SRC_V3 = '/img/car-buying/private-party/icon_coin_falling_into_hand-v2.svg';
const IMG_SRC_MOBILE_V2 = '/img/car-buying/private-party/lady-in-chair.png';
const BENEFITS_V3 = [
  `<span class="fw-bold">Get more for your car</span> by selling to private buyers`,
  `List on a trusted marketplace with a <span class="fw-bold">large car shopper audience</span>`,
  'Secure payment and paperwork via Caramel&reg;',
];
const BENEFITS_V4 = ['Make more selling privately', 'Get paid securely via Caramel&reg;'];

export const PRIVATE_PARTY_SELL_CAR_TED7310 = {
  chal1: {
    header: `List Your Car for Private Sale on Edmunds. It's Easy!`,
    headerMobile: `List Your Car for Private Sale on Edmunds`,
    imageSrc: IMG_SRC_V3,
    benefits: BENEFITS_V4,
  },
};

export const SELL_IT_YOURSELF = 'Sell it yourself';
export const SELL_TO_DEALER = 'Sell to a dealer';
export const SELLING_METHODS = [
  { title: SELL_TO_DEALER, text: 'Fast, no-haggle offers' },
  { title: SELL_IT_YOURSELF, text: 'Make more, online paperwork' },
];

export const PRIVATE_PARTY_SELL_CAR_OFFER_DETAIL_BTN = {
  header: `Sell Your Car Yourself on Edmunds. It's Easy!`,
  headerMobile: `Sell Your Car Yourself on Edmunds!`,
  imageSrc: IMG_SRC_V3,
  benefits: BENEFITS_V4,
};

export const PRIVATE_PARTY_SELL_CAR_WIDGET = {
  header: `List Your Car for Private Sale on Edmunds. \n<span class="text-blue-50 fw-bold">It's Easy!</span>`,
  benefits: BENEFITS_V3,
  imageSrc: IMG_SRC_V2,
  imageSrcMobile: IMG_SRC_MOBILE_V2,
};

export const PRIVATE_PARTY_NO_OFFER_ALMOST_DONE_STEPS = [
  {
    label: 'Vehicle information',
    status: 'complete',
    iconClassName: 'icon-checkmark size-10',
  },
  {
    label: 'Set your price',
    status: 'active',
    iconText: '2',
  },
  {
    label: 'Upload photos',
    status: 'upcoming',
    iconText: '3',
  },
];

export const CREATIVE_ID_HOMEPAGE_PP_BUTTON = 'edm-entry-inventory-search-private-party-promotion';

/* Create  listing constants */

export const TAB_ID = {
  LICENSE_PLATE: 'LICENSE_PLATE',
  VIN: 'VIN',
  ADDRESS: 'ADDRESS',
};

export const TAB_IDS = {
  LICENSE_PLATE_TAB: 'LICENSE_PLATE_TAB',
  VIN_TAB: 'VIN_TAB',
};

export const TAB_TITLES = {
  [TAB_IDS.LICENSE_PLATE_TAB]: 'License Plate',
  [TAB_IDS.VIN_TAB]: 'VIN',
};

export const LICENSE_PLATE_ERROR_MESSAGES_MAP = {
  licensePlate: {
    INVALID: 'Please enter a valid license plate',
    LANDING_INVALID:
      'We could not find that license plate. If your license plate is a special plate (vanity, disabled person, special interest, etc.)',
    ERROR: "We're sorry, we could not look up your license plate at this time.",
    NO_STYLES:
      "We're sorry. We were unable to locate your license plate. Please try entering a VIN or a Make, Model, Year instead.",
  },
  zipCode: {
    INVALID: 'Please enter a valid ZIP code',
  },
};

export const LICENSE_PLATE_MAX_LENGTH = 9;
export const CONTACT_SUPPORT_EMAIL = 'help@edmunds.com';

export const CREATE_LISTING_STEP_HEADING = 'Sell Your Car Privately with Confidence';
export const CREATE_LISTING_STEP_DESCRIPTION = `List your car <span class="fw-bold">for sale by owner</span> by entering your License Plate or VIN. We'll pull your vehicle's details to help you get the best <span class="fw-bold">market value</span> for your sale.`;
